import { DisplayOnBreakpoints } from "@dotcom/ui";
import styled from "@emotion/styled";
import {
  Divider,
  Grid,
  GridColumn,
  H2,
  H3,
  MediaQueries,
  Paragraph,
  Section,
  Spacer,
  Spacings,
  createCustomFontSize,
  createCustomLetterSpacing,
  createCustomLineHeight,
} from "@polestar/component-warehouse-react";
interface TextBlockProps {
  readonly title?: string;
  readonly blocks: Array<{
    id: string;
    title: string;
    body: string;
  }>;
}
const StyledH2 = styled(H2)`
  white-space: pre-line;
`;

const StyledGrid = styled(Grid)`
  grid-row-gap: 0;

  ${MediaQueries.tablet} {
    grid-row-gap: 0;
  }
`;

const TextBlock = ({ title, blocks }: TextBlockProps) => {
  return (
    <Section>
      <StyledGrid>
        <GridColumn
          span={{ mobile: 4, tablet: 8, desktop: 8 }}
          offset={{ mobile: 0, desktop: 4 }}
        >
          <StyledH2
            variant={{
              fontSize: {
                mobile: createCustomFontSize(3.5),
                desktop: createCustomFontSize(5),
              },
              lineHeight: {
                mobile: createCustomLineHeight(3.625),
                desktop: createCustomLineHeight(5),
              },
              letterSpacing: createCustomLetterSpacing(-0.25),
            }}
          >
            {title}
          </StyledH2>
        </GridColumn>

        <Spacer
          spacing={{
            mobile: Spacings.large,
            tablet: Spacings.xLarge,
            desktop: Spacings.xxLarge,
          }}
        />
      </StyledGrid>

      <Divider
        spacing={{
          mobile: Spacings.large,
          tablet: Spacings.xLarge,
          desktop: Spacings.large,
        }}
      />

      <StyledGrid>
        {blocks.map((block, index) => {
          return (
            <GridColumn
              key={block.id}
              span={{ mobile: 4, tablet: 8, desktop: 4 }}
            >
              <H3>{block.title}</H3>

              <Spacer
                spacing={{ mobile: Spacings.small, desktop: Spacings.medium }}
              />
              <Paragraph>{block.body}</Paragraph>

              {blocks.length !== index + 1 && (
                <DisplayOnBreakpoints
                  display={{
                    mobile: "block",
                    tablet: "block",
                    desktop: "none",
                    desktopWide: "none",
                  }}
                >
                  <Divider
                    spacing={{
                      mobile: Spacings.large,
                      tablet: Spacings.xLarge,
                    }}
                  />
                </DisplayOnBreakpoints>
              )}
            </GridColumn>
          );
        })}
      </StyledGrid>
    </Section>
  );
};

export default TextBlock;
